var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "setting-form" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-user-circle-o" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("settings.titles.me")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container full-height std-padding" }, [
        _c(
          "div",
          {
            staticClass:
              "row align-items-center justify-content-center full-height",
          },
          [
            _c(
              "div",
              { staticClass: "col-12 col-xl-9 full-height" },
              [
                _c("UiCard", [
                  _c("div", { staticClass: "full-height" }, [
                    _c("div", { staticClass: "d-flex flex-column mb-4" }, [
                      _c("h2", { staticClass: "m-0" }, [
                        _c("i", { staticClass: "fa fa-user-circle-o mr-1" }),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("settings.titles.infos")) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-sm text-gray-500 tw-ms-10" },
                        [_vm._v(_vm._s(_vm.user.clientCode))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.name"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.nom,
                              expression: "user.nom",
                            },
                            { name: "validate", rawName: "v-validate" },
                          ],
                          staticClass: "form-input col",
                          attrs: {
                            readonly: "readonly",
                            type: "text",
                            "data-vv-rules": "required",
                            name: "nom",
                            "data-vv-as": "Prénom NOM",
                          },
                          domProps: { value: _vm.user.nom },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.user, "nom", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.showErrors["nom"] &&
                                  _vm.errors.has("nom"),
                                expression:
                                  "showErrors['nom'] && errors.has('nom')",
                              },
                            ],
                            staticClass: "form-input-error",
                            on: {
                              click: function ($event) {
                                return _vm.hideError("nom")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.errors.first("nom")))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.mail"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email",
                            },
                            { name: "validate", rawName: "v-validate" },
                          ],
                          staticClass: "form-input col",
                          attrs: {
                            readonly: "readonly",
                            type: "text",
                            "data-vv-rules": "required|email",
                            "data-vv-as": "E-mail",
                            name: "email",
                          },
                          domProps: { value: _vm.user.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.user, "email", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.showErrors["email"] &&
                                  _vm.errors.has("email"),
                                expression:
                                  "showErrors['email'] && errors.has('email')",
                              },
                            ],
                            staticClass: "form-input-error",
                            on: {
                              click: function ($event) {
                                return _vm.hideError("email")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.errors.first("email")))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.phone"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userTelephone,
                              expression: "userTelephone",
                            },
                          ],
                          staticClass: "form-input col",
                          attrs: {
                            readonly: "readonly",
                            type: "text",
                            name: "phone",
                            placeholder: "__.__.__.__.__",
                          },
                          domProps: { value: _vm.userTelephone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.userTelephone = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.password"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "Btn",
                            {
                              staticClass: "primary reverse col",
                              staticStyle: { "text-align": "center" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openPasswordModal($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("settings.form.passwordEdit")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.language"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.locale,
                                expression: "locale",
                              },
                            ],
                            staticClass: "form-input w-full",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.locale = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.langs, function (lang, key) {
                            return _c(
                              "option",
                              { domProps: { value: lang.key } },
                              [_vm._v(_vm._s(lang.label))]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c(
                            "Btn",
                            {
                              staticClass: "primary w-full",
                              staticStyle: { "text-align": "center" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.changeLanguage($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("global.edit")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h2", { staticClass: "mt-5" }, [
                      _c("i", { staticClass: "fa fa-bell mr-1" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("settings.titles.notifs")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("label", { staticClass: "notif-label" }, [
                            _vm._v(_vm._s(_vm.$t("settings.form.webnotifs"))),
                          ]),
                          _vm._v(" "),
                          _c("UiBadge", {
                            attrs: {
                              type: _vm.notificationEnabled
                                ? "success"
                                : "secondary",
                              label: _vm.notificationEnabled
                                ? _vm.$t("settings.form.webnotifs_enabled")
                                : _vm.$t("settings.form.webnotifs_disabled"),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "col",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("settings.form.webnotifsdetails", {
                              theme: _vm.appTheme,
                            })
                          ),
                        },
                        on: { click: _vm.handleWebNotifications },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.alertsound"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("UiSwitch", {
                            attrs: { "true-value": 1, "false-value": 0 },
                            on: { input: _vm.toggleSound },
                            model: {
                              value: _vm.playSound,
                              callback: function ($$v) {
                                _vm.playSound = $$v
                              },
                              expression: "playSound",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-row row",
                        class: { disabled: _vm.playSound === 0 },
                      },
                      [
                        _c("label", { staticClass: "col-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("settings.form.alertsoundLoop"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("UiSwitch", {
                              attrs: { "true-value": 1, "false-value": 0 },
                              on: { input: _vm.toggleSoundLoop },
                              model: {
                                value: _vm.playSoundLoop,
                                callback: function ($$v) {
                                  _vm.playSoundLoop = $$v
                                },
                                expression: "playSoundLoop",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h2", { staticClass: "mt-5" }, [
                      _c("i", { staticClass: "fa fa-desktop mr-1" }),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("settings.titles.ui")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.gpsaccuracy"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("UiSwitch", {
                            attrs: { "true-value": 1, "false-value": 0 },
                            on: { input: _vm.toggleGpsAccuraccy },
                            model: {
                              value: _vm.gpsAccuracy,
                              callback: function ($$v) {
                                _vm.gpsAccuracy = $$v
                              },
                              expression: "gpsAccuracy",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.denseMode"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("UiSwitch", {
                            attrs: { "true-value": 1, "false-value": 0 },
                            on: { input: _vm.toggleDenseMode },
                            model: {
                              value: _vm.denseMode,
                              callback: function ($$v) {
                                _vm.denseMode = $$v
                              },
                              expression: "denseMode",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.globalPerPage"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.globalPerPage,
                                expression: "globalPerPage",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "form-input col",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return _vm._n(val)
                                    })
                                  _vm.globalPerPage = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.updateGlobalPerPage,
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { val: "10" } }, [
                              _vm._v("10"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { val: "20" } }, [
                              _vm._v("20"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { val: "30" } }, [
                              _vm._v("30"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { val: "50" } }, [
                              _vm._v("50"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { val: "100" } }, [
                              _vm._v("100"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "mt-5 d-inline-flex align-items-center" },
                      [
                        _c("i", {
                          staticClass: "mr-2",
                          domProps: { innerHTML: _vm._s(_vm.cookieLogo) },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("settings.titles.cookies")) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("settings.form.cookiesManager"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "Btn",
                            {
                              staticClass: "primary reverse col",
                              staticStyle: { "text-align": "center" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openCookiesManager($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("settings.form.cookiesManagerEdit")
                                ) + "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-row row",
                        staticStyle: {
                          "text-align": "center",
                          "margin-bottom": "0",
                          display: "block",
                        },
                      },
                      [_c("small", [_vm._v("Version: " + _vm._s(_vm.version))])]
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("Toolbar"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }